import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import {I18n} from "../../../I18n";
import React from "react";

const DeleteModal = props => {
    return (
        <Modal
            className="del-modal"
            isOpen={props.isOkModal}
            toggle={props.toggle}
            centered
        >
            <ModalHeader>
                {I18n[props.lang].SURE}
            </ModalHeader>
            <ModalBody
                className="d-md-flex justify-content-end">
                <Button
                    color="danger"
                    className="ml-1"
                    onClick={props.onDeleteClick}
                    disabled={props.isDeleteDisable}>
                    {props.isDeleteDisable ? <i className="mr-2 fa fa-spinner fa-spin"/> : null} {I18n[props.lang].DELETE}
                </Button>
                <Button
                    color="secondary"
                    className="ml-1"
                    onClick={() => props.toggle(null)}>
                    {I18n[props.lang].CANCEL}
                </Button>
            </ModalBody>
        </Modal>
    )
};

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/components/Common/Modal/DeleteModal.js